import { IssueTypeDetails } from '../model/issue-type-details';
import { IssueType } from '../model/issue-type';
import { Identity } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IssueTypeAdministrationService {

  constructor(private appServerAPI: AppServerAPI) { }

  public getIssueTypes(): Observable<IssueType[]> {
    return this.appServerAPI.execute<IssueType[]>('/client/admin/issue-type', {});
  }

  public getIssueTypeDetails(identity: Identity): Observable<IssueTypeDetails> {
    return this.appServerAPI.execute<IssueTypeDetails>('/client/admin/issue-type/details', identity);
  }

  public saveIssueType(details: IssueTypeDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/issue-type/save', details);
  }

  public createIssueType(details: IssueTypeDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/issue-type/create', details);
  }

  public deleteIssueType(identity: Identity): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/issue-type/delete', identity);
  }
}
